$(function () {
	// ---- Product detail gallery slider ----
	if ($('.product-detail-image').length) {
		const $gallery = $('.product-detail-image');

		function initProductGallerySlider() {
			if (!$gallery.hasClass('slick-initialized')) {
				$gallery.slick({
					dots: true,
					arrows: true,
					infinite: false,
					adaptiveHeight: false,
					swipeToSlide: true,
				});
			}
		}

		initProductGallerySlider();
	}

	const $imageZoomModal = $('#productImageZoomModal');
	if ($imageZoomModal.length) {
		const $zoomTriggers = $('.product-detail-image .product-gallery-zoom-trigger');
		const $zoomImage = $imageZoomModal.find('.product-image-zoom-image');
		const $zoomCounter = $imageZoomModal.find('.product-image-zoom-counter');
		let activeZoomIndex = 0;

		function showZoomImage(index) {
			activeZoomIndex = (index + $zoomTriggers.length) % $zoomTriggers.length;
			const $image = $zoomTriggers.eq(activeZoomIndex).find('img');

			$zoomImage.attr({
				src: $image.attr('src'),
				alt: $image.attr('alt') || '',
			});
			$zoomCounter.text((activeZoomIndex + 1) + ' / ' + $zoomTriggers.length);
		}

		$zoomTriggers.on('click', function () {
			activeZoomIndex = $zoomTriggers.index(this);
			showZoomImage(activeZoomIndex);
			window.bootstrap.Modal.getOrCreateInstance($imageZoomModal[0]).show();
		});

		$imageZoomModal.find('.product-image-zoom-prev').on('click', function () {
			showZoomImage(activeZoomIndex - 1);
		});
		$imageZoomModal.find('.product-image-zoom-next').on('click', function () {
			showZoomImage(activeZoomIndex + 1);
		});
		$imageZoomModal.on('keydown', function (event) {
			if (event.key === 'ArrowLeft') {
				event.preventDefault();
				showZoomImage(activeZoomIndex - 1);
			} else if (event.key === 'ArrowRight') {
				event.preventDefault();
				showZoomImage(activeZoomIndex + 1);
			}
		});

		if ($zoomTriggers.length < 2) {
			$imageZoomModal.find('.product-image-zoom-prev, .product-image-zoom-next').prop('hidden', true);
		}
	}

	// Only run on product list page
	if (!$('#productList').length) return;

	var basePath = window.location.pathname.replace(/\/$/, '');
	var gridUrl = $('#productList').data('gridUrl') || (basePath + '/grid');
	var isEmbeddedGrid = $('#productList').data('embedded') === true || $('#productList').data('embedded') === 1;
	var currentXHR = null;
	var searchTimer = null;
	var externalParams = [];
	var $productTypeFilter = $('#productTypeFilter');
	var $breadcrumbType = $('#productListBreadcrumbType');
	var $breadcrumbTypeWrap = $('#productListBreadcrumbTypeWrap');
	var activeProductType = null;
	var $priceSlider = $('#plfPriceSlider');
	var $priceMinRange = $('#plfPriceMin');
	var $priceMaxRange = $('#plfPriceMax');
	var $priceMinValue = $('#plfPriceMinValue');
	var $priceMaxValue = $('#plfPriceMaxValue');

	function normalizeProductTypeValue(value) {
		if (value === null || value === undefined) return null;
		var normalized = String(value).trim();
		return normalized.length ? normalized : null;
	}

	function syncProductTypeButtons() {
		if (!$productTypeFilter.length) return;

		$productTypeFilter.find('.product-type-filter-btn').each(function () {
			var $btn = $(this);
			var buttonTypeId = normalizeProductTypeValue($btn.data('typeId'));
			var isActive = !!activeProductType && buttonTypeId === activeProductType;

			$btn.toggleClass('is-active', isActive);
			$btn.attr('aria-pressed', isActive ? 'true' : 'false');
		});
	}

	function syncProductTypeBreadcrumb() {
		if (!$breadcrumbType.length || !$breadcrumbTypeWrap.length) return;

		var label = '';
		if (activeProductType) {
			var $activeButton = $productTypeFilter.find('.product-type-filter-btn[data-type-id="' + activeProductType + '"]').first();
			if ($activeButton.length) {
				label = String($activeButton.data('typeName') || $activeButton.attr('title') || '').trim();
			}
		}

		if (!label) {
			label = String($breadcrumbType.data('defaultLabel') || '').trim();
		}

		if (label) {
			$breadcrumbType.text(label);
			$breadcrumbTypeWrap.removeClass('d-none');
		} else {
			$breadcrumbType.text('');
			$breadcrumbTypeWrap.addClass('d-none');
		}
	}

	function setActiveProductType(typeId) {
		activeProductType = normalizeProductTypeValue(typeId);
		syncProductTypeButtons();
		syncProductTypeBreadcrumb();
	}

	function hasPriceFilter() {
		return $priceSlider.length && $priceMinRange.length && $priceMaxRange.length;
	}

	function formatPriceValue(value) {
		return Number(value || 0).toLocaleString('hu-HU') + ' Ft';
	}

	function normalizeSearchInput(value) {
		if (!value) return '';
		return value
			.toString()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.replace(/[^a-z0-9\s]+/g, ' ')
			.replace(/\s+/g, ' ')
			.trim();
	}

	function updatePriceSliderUi() {
		if (!hasPriceFilter()) return;

		var min = parseInt($priceSlider.data('min'), 10) || 0;
		var max = parseInt($priceSlider.data('max'), 10) || min;
		var left = parseInt($priceMinRange.val(), 10);
		var right = parseInt($priceMaxRange.val(), 10);

		if (isNaN(left)) left = min;
		if (isNaN(right)) right = max;

		left = Math.max(min, Math.min(left, right));
		right = Math.min(max, Math.max(right, left));

		$priceMinRange.val(left);
		$priceMaxRange.val(right);

		$priceMinValue.text(formatPriceValue(left));
		$priceMaxValue.text(formatPriceValue(right));

		var range = Math.max(max - min, 1);
		var fromPct = ((left - min) / range) * 100;
		var toPct = ((right - min) / range) * 100;

		$('#plfPriceRangeFill').css({
			left: fromPct + '%',
			width: (toPct - fromPct) + '%'
		});
	}

	function setPriceBounds(minValue, maxValue, preserveSelection) {
		if (!hasPriceFilter()) return;

		var min = parseInt(minValue, 10);
		var max = parseInt(maxValue, 10);
		if (isNaN(min)) min = 0;
		if (isNaN(max)) max = min;
		if (max < min) max = min;

		var prevMin = parseInt($priceMinRange.val(), 10);
		var prevMax = parseInt($priceMaxRange.val(), 10);
		if (isNaN(prevMin)) prevMin = min;
		if (isNaN(prevMax)) prevMax = max;

		$priceSlider.attr('data-min', min).data('min', min);
		$priceSlider.attr('data-max', max).data('max', max);
		$priceMinRange.attr({ min: min, max: max });
		$priceMaxRange.attr({ min: min, max: max });

		if (preserveSelection) {
			$priceMinRange.val(Math.max(min, Math.min(prevMin, max)));
			$priceMaxRange.val(Math.max(min, Math.min(prevMax, max)));
		} else {
			$priceMinRange.val(min);
			$priceMaxRange.val(max);
		}

		updatePriceSliderUi();
	}

	function resetPriceFilter() {
		if (!hasPriceFilter()) return;
		$priceMinRange.val($priceSlider.data('min'));
		$priceMaxRange.val($priceSlider.data('max'));
		updatePriceSliderUi();
	}

	function isPriceFilterActive() {
		if (!hasPriceFilter()) return false;
		var min = parseInt($priceSlider.data('min'), 10) || 0;
		var max = parseInt($priceSlider.data('max'), 10) || min;
		var left = parseInt($priceMinRange.val(), 10) || min;
		var right = parseInt($priceMaxRange.val(), 10) || max;
		return left !== min || right !== max;
	}

	// ========================================================
	// Build query string from current filter/sort/page state
	// ========================================================
	function buildQueryString() {
		var parts = [];

		// All checkbox filters – strip 'plf_' prefix from name (e.g. 'plf_gender[]' → 'gender[]')
		$('#plfPanel input[type="checkbox"]:checked').each(function () {
			var plfName = $(this).attr('name');                       // e.g. "plf_gender[]"
			var name = plfName ? plfName.replace(/^plf_/, '') : null; // e.g. "gender[]"
			var val = $(this).val();
			if (name && val !== undefined) {
				parts.push(name + '=' + encodeURIComponent(val));
			}
		});

		// Sort (radio) – m_sort input in sort dropdown
		var sort = $('#sortDropdownMenu input[name="m_sort"]:checked').val();
		if (sort) {
			parts.push('sort=' + encodeURIComponent(sort));
		}

		// Product type selector (single select)
		if (activeProductType) {
			parts.push('category=' + encodeURIComponent(activeProductType));
		}

		// Search
		var search = $('.product-list-search-input').val();
		var normalizedSearch = normalizeSearchInput(search);
		if (normalizedSearch) {
			parts.push('search=' + encodeURIComponent(normalizedSearch));
		}

		// Price range
		if (hasPriceFilter()) {
			var globalMin = parseInt($priceSlider.data('min'), 10) || 0;
			var globalMax = parseInt($priceSlider.data('max'), 10) || globalMin;
			var currentMin = parseInt($priceMinRange.val(), 10);
			var currentMax = parseInt($priceMaxRange.val(), 10);

			if (!isNaN(currentMin) && currentMin > globalMin) {
				parts.push('min_price=' + currentMin);
			}
			if (!isNaN(currentMax) && currentMax < globalMax) {
				parts.push('max_price=' + currentMax);
			}
		}

		// Page
		var page = parseInt($('.product-list-pager-current input').val()) || 1;
		if (page > 1) {
			parts.push('page=' + page);
		}

		// Preserved external params (from URL, no matching sidebar element)
		if (externalParams.length) {
			parts = parts.concat(externalParams);
		}

		return parts.join('&');
	}

	// ========================================================
	// Push state to browser URL
	// ========================================================
	function updateUrl(qs, replaceHistory) {
		var newUrl = basePath + (qs ? '?' + qs : '');
		var currentUrl = window.location.pathname + window.location.search;
		if (newUrl === currentUrl) return;

		if (replaceHistory) {
			window.history.replaceState({}, '', newUrl);
		} else {
			window.history.pushState({}, '', newUrl);
		}
	}

	// ========================================================
	// AJAX load product grid
	// ========================================================
	function loadProductGrid(options) {
		options = options || {};
		var writeHistory = options.writeHistory !== false;
		var replaceHistory = options.replaceHistory === true;

		var qs = buildQueryString();
		if (writeHistory && !isEmbeddedGrid) {
			updateUrl(qs, replaceHistory);
		}

		if (currentXHR) currentXHR.abort();

		$('.product-list-loading').show();

		$('#productList').css('opacity', '0.5');

		currentXHR = $.ajax({
			url: gridUrl + (qs ? '?' + qs : ''),
			method: 'GET',
			dataType: 'json',
			success: function (response) {
				$('.product-list-loading').hide();
				$('#productList').html(response.html).css('opacity', '1');
				if (response.priceRange && hasPriceFilter()) {
					setPriceBounds(response.priceRange.min, response.priceRange.max, !options.resetPriceSelection);
				}
				updatePagination(response.pagination);
			},
			error: function (xhr) {
				$('.product-list-loading').hide();
				if (xhr.statusText !== 'abort') {
					$('#productList').css('opacity', '1');
				}
			}
		});
	}

	// ========================================================
	// Update pagination controls
	// ========================================================
	function updatePagination(p) {
		var $pag = $('.product-list-pagination');

		if (p.lastPage <= 1) {
			$pag.hide();
			return;
		}

		$pag.show();

		// Current page input
		$('.product-list-pager-current input').val(p.currentPage);

		// "of X pages" info
		$('.product-list-pager-info').text(window.Lang.pagination_info.replace('{n}', p.lastPage));

		// Prev arrow
		var $prev = $('.product-list-pager-prev');
		if (p.onFirstPage) {
			$prev.addClass('disabled').attr('aria-disabled', 'true');
		} else {
			$prev.removeClass('disabled').removeAttr('aria-disabled');
		}

		// Next arrow
		var $next = $('.product-list-pager-next');
		if (!p.hasMorePages) {
			$next.addClass('disabled').attr('aria-disabled', 'true');
		} else {
			$next.removeClass('disabled').removeAttr('aria-disabled');
		}
	}

	// ========================================================
	// Initialize filter/sort/page state from current URL
	// ========================================================
	function initFromUrl() {
		var params = new URLSearchParams(window.location.search);
		externalParams = [];
		var selectedProductTypeFromUrl = null;

		var managedKeys = ['sort', 'search', 'page', 'min_price', 'max_price', 'category', 'category[]'];

		params.forEach(function (value, key) {
			if (managedKeys.indexOf(key) !== -1) return;

			// Try to find a matching checkbox in the filter panel (name has 'plf_' prefix)
			var plfKey = 'plf_' + key;  // e.g. 'gender[]' → 'plf_gender[]'
			var $checkbox = $('#plfPanel input[name="' + plfKey + '"][value="' + value + '"]');

			if ($checkbox.length) {
				$checkbox.prop('checked', true);
			} else {
				// Preserve params that have no matching filter
				externalParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
			}
		});

		selectedProductTypeFromUrl = params.get('category') || params.get('category[]');
		if (selectedProductTypeFromUrl) {
			setActiveProductType(selectedProductTypeFromUrl);
		} else {
			setActiveProductType($productTypeFilter.data('defaultType'));
		}

		// Sort
		var sort = params.get('sort');
		if (sort) {
			$('#sortDropdownMenu input[name="m_sort"][value="' + sort + '"]').prop('checked', true);
		}

		// Search
		var search = params.get('search');
		if (search) {
			$('.product-list-search-input').val(search);
		}

		if (hasPriceFilter()) {
			var minBound = parseInt($priceSlider.data('min'), 10) || 0;
			var maxBound = parseInt($priceSlider.data('max'), 10) || minBound;
			var minPrice = parseInt(params.get('min_price'), 10);
			var maxPrice = parseInt(params.get('max_price'), 10);

			if (!isNaN(minPrice)) {
				$priceMinRange.val(Math.max(minBound, Math.min(minPrice, maxBound)));
			}
			if (!isNaN(maxPrice)) {
				$priceMaxRange.val(Math.max(minBound, Math.min(maxPrice, maxBound)));
			}

			updatePriceSliderUi();
		}

		// Page
		var page = params.get('page');
		if (page) {
			$('.product-list-pager-current input').val(page);
		}

		updateFilterGroupActiveState();
	}

	// ========================================================
	// Reset page to 1
	// ========================================================
	function resetPage() {
		$('.product-list-pager-current input').val(1);
	}

	function resetProductFilters() {
		$('#plfPanel input[type="checkbox"]').prop('checked', false);
		$('#sortDropdownMenu input[name="m_sort"]').prop('checked', false);
		$('.product-list-search-input').val('');
		externalParams = [];
		resetPriceFilter();
		resetPage();
		updateFilterGroupActiveState();
	}

	// ========================================================
	// Filter Panel (plf) – open / close / accordion
	// ========================================================
	var $plfPanel = $('#plfPanel');
	var $plfBackdrop = $('#plfBackdrop');

	function plfOpen() {
		$plfPanel.addClass('plf-panel--open');
		$plfBackdrop.addClass('plf-backdrop--visible');
		$('body').addClass('plf-no-scroll');
		$('#plfOpenBtn').attr('aria-expanded', 'true');
	}

	function plfClose() {
		$plfPanel.removeClass('plf-panel--open');
		$plfBackdrop.removeClass('plf-backdrop--visible');
		$('body').removeClass('plf-no-scroll');
		$('#plfOpenBtn').attr('aria-expanded', 'false');
	}

	function updateFilterGroupActiveState() {
		$('.plf-acc-item').each(function () {
			var $group = $(this);
			var hasActive = $group.find('input[type="checkbox"]:checked').length > 0;
			if ($group.data('filter-group') === 'price' && isPriceFilterActive()) {
				hasActive = true;
			}
			$group.toggleClass('plf-acc-item--active', hasActive);
		});
	}

	// Open panel
	$('#plfOpenBtn').on('click', function () {
		plfOpen();
	});

	// Close via backdrop
	$plfBackdrop.on('click', function () {
		plfClose();
	});

	// Close buttons (main + sub)
	$(document).on('click', '#plfPanel .plf-close-btn', function () {
		plfClose();
	});

	// Accordion toggle
	$(document).on('click', '#plfPanel .plf-acc-trigger', function () {
		var $btn = $(this);
		var $section = $btn.closest('.plf-acc-item');
		var isOpen = $section.hasClass('plf-acc-item--open');
		$section.toggleClass('plf-acc-item--open', !isOpen);
		$btn.attr('aria-expanded', String(!isOpen));
	});

	// "Alkalmaz" on main panel → close + load + scroll
	$('#plfApplyAll').on('click', function () {
		updateFilterGroupActiveState();
		resetPage();
		loadProductGrid();
		plfClose();
		$('html, body').animate({ scrollTop: 0 }, 300);
	});

	// "Törlés" on main panel → clear all filters + load
	$('#plfClearAll').on('click', function () {
		$('#plfPanel input[type="checkbox"]').prop('checked', false);
		resetPriceFilter();
		setActiveProductType($productTypeFilter.data('defaultType'));
		updateFilterGroupActiveState();
		resetPage();
		loadProductGrid();
	});

	$(document).on('click', '.product-type-filter-btn', function () {
		var nextTypeId = normalizeProductTypeValue($(this).data('typeId'));
		if (!nextTypeId || nextTypeId === activeProductType) return;

		resetProductFilters();
		setActiveProductType(nextTypeId);
		loadProductGrid({ resetPriceSelection: true });
	});

	$('#productListBackBtn').on('click', function () {
		window.history.back();
	});

	// Price inputs sync
	if (hasPriceFilter()) {
		$priceMinRange.on('input change', function () {
			var minVal = parseInt($priceMinRange.val(), 10) || 0;
			var maxVal = parseInt($priceMaxRange.val(), 10) || 0;
			if (minVal > maxVal) {
				$priceMinRange.val(maxVal);
			}
			updatePriceSliderUi();
			updateFilterGroupActiveState();
		});

		$priceMaxRange.on('input change', function () {
			var minVal = parseInt($priceMinRange.val(), 10) || 0;
			var maxVal = parseInt($priceMaxRange.val(), 10) || 0;
			if (maxVal < minVal) {
				$priceMaxRange.val(minVal);
			}
			updatePriceSliderUi();
			updateFilterGroupActiveState();
		});
	}

	$(document).on('change', '#plfPanel input[type="checkbox"]', function () {
		updateFilterGroupActiveState();
	});

	// Keyboard: Escape closes panel
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $plfPanel.hasClass('plf-panel--open')) {
			plfClose();
		}
	});

	// ========================================================
	// Event handlers
	// ========================================================

	// ========================================================
	// Sort Dropdown
	// ========================================================
	var $sortToggle = $('#sortDropdownToggle');
	var $sortMenu = $('#sortDropdownMenu');

	function sortDropdownOpen() {
		$sortMenu.addClass('sort-dropdown-menu--open');
		$sortToggle.attr('aria-expanded', 'true');
	}

	function sortDropdownClose() {
		$sortMenu.removeClass('sort-dropdown-menu--open');
		$sortToggle.attr('aria-expanded', 'false');
	}

	$sortToggle.on('click', function (e) {
		e.stopPropagation();
		if ($sortMenu.hasClass('sort-dropdown-menu--open')) {
			sortDropdownClose();
		} else {
			sortDropdownOpen();
		}
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('#sortDropdown').length) {
			sortDropdownClose();
		}
	});

	// Sort radio change → load + close dropdown
	$('#sortDropdownMenu input[name="m_sort"]').on('change', function () {
		resetPage();
		loadProductGrid();
		sortDropdownClose();
	});
	// Search input (debounced)
	$('.product-list-search-input').on('input', function () {
		clearTimeout(searchTimer);
		searchTimer = setTimeout(function () {
			resetPage();
			loadProductGrid();
		}, 400);
	});

	$('.product-list-search-input').on('keydown', function (e) {
		if (e.key !== 'Enter') return;
		e.preventDefault();
		clearTimeout(searchTimer);
		resetPage();
		loadProductGrid();
	});

	// Search button click
	$('.product-list-search-btn').on('click', function (e) {
		e.preventDefault();
		clearTimeout(searchTimer);
		resetPage();
		loadProductGrid();
	});

	// Pagination: prev arrow
	$(document).on('click', '.product-list-pager-prev:not(.disabled)', function () {
		var current = parseInt($('.product-list-pager-current input').val()) || 1;
		if (current > 1) {
			$('.product-list-pager-current input').val(current - 1);
			loadProductGrid();
			$('html, body').animate({ scrollTop: $('#productList').offset().top - 20 }, 300);
		}
	});

	// Pagination: next arrow
	$(document).on('click', '.product-list-pager-next:not(.disabled)', function () {
		var current = parseInt($('.product-list-pager-current input').val()) || 1;
		$('.product-list-pager-current input').val(current + 1);
		loadProductGrid();
		$('html, body').animate({ scrollTop: $('#productList').offset().top - 20 }, 300);
	});

	// Pagination: page input (Enter key)
	$(document).on('keydown', '.product-list-pager-current input', function (e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			var page = parseInt($(this).val()) || 1;
			if (page < 1) page = 1;
			$(this).val(page);
			loadProductGrid();
			$('html, body').animate({ scrollTop: $('#productList').offset().top - 20 }, 300);
		}
	});

	// Browser back/forward navigation
	$(window).on('popstate', function () {
		$('#plfPanel input[type="checkbox"]').prop('checked', false);
		resetPriceFilter();
		setActiveProductType(null);
		$('#sortDropdownMenu input[name="m_sort"]').prop('checked', false);
		$('.product-list-search-input').val('');
		$('.product-list-pager-current input').val(1);
		initFromUrl();
		loadProductGrid({ writeHistory: false });
	});

	// ========================================================
	// Init
	// ========================================================
	if (hasPriceFilter()) {
		setPriceBounds($priceSlider.data('min'), $priceSlider.data('max'), false);
	}
	initFromUrl();
	updateFilterGroupActiveState();
	loadProductGrid({ replaceHistory: true });
});